/**
 * RETAIL PRODUCT FINDER MODULE
 * Self-contained. Import only from /shared or within this module.
 * Do not import from other modules directly.
 */

// Public entry point. The app composition root imports ONLY from here; nothing
// deep-imports this module's internals.
import RetailFinder from "./routes/RetailFinder.jsx";

export const retailProductFinderRoutes = [
  { path: "/retail-finder", component: RetailFinder },
];

// Listed on the support ticket form's "Area" dropdown (collected automatically).
export const moduleMeta = { key: "retail-product-finder", label: "Retail Product Finder" };
